$( document ).on("turbo:load", initStructureGpsPointModal);

function initStructureGpsPointModal() {
  if ($('#gps-point-modal').length > 0) {
    $('[data-function="existing-gps-point-list"]').hide();
    $('a[data-function="existing-gps-point"]').click(function(e){
      e.preventDefault();
      $('[data-function="existing-gps-point-list"]').show();
    });
  }
}
